/**
 */
import * as CryptoJS from "crypto-js";

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (typeof time === "string") {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time);
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), "/");
            }
        }

        if (typeof time === "number" && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        return value.toString().padStart(2, "0");
    });
    return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (("" + time).length === 10) {
        time = parseInt(time) * 1000;
    } else {
        time = +time;
    }
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if (diff < 30) {
        return "刚刚";
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + "分钟前";
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + "小时前";
    } else if (diff < 3600 * 24 * 2) {
        return "1天前";
    }
    if (option) {
        return parseTime(time, option);
    } else {
        return (
            d.getMonth() +
            1 +
            "月" +
            d.getDate() +
            "日" +
            d.getHours() +
            "时" +
            d.getMinutes() +
            "分"
        );
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
    if (!search) {
        return {};
    }
    const obj = {};
    const searchArr = search.split("&");
    searchArr.forEach((v) => {
        const index = v.indexOf("=");
        if (index !== -1) {
            const name = v.substring(0, index);
            const val = v.substring(index + 1, v.length);
            obj[name] = val;
        }
    });
    return obj;
}

/**
 *加密处理
 */
export const encryption = (params) => {
    const { data, type, param, key } = params;
    const result = JSON.parse(JSON.stringify(data));
    if (type === "Base64") {
        param.forEach((ele) => {
            result[ele] = btoa(result[ele]);
        });
    } else {
        param.forEach((ele) => {
            var data = result[ele];
            const keyObj = CryptoJS.enc.Latin1.parse(key);
            var iv = keyObj;
            // 加密
            var encrypted = CryptoJS.AES.encrypt(data, keyObj, {
                iv: iv,
                mode: CryptoJS.mode.CFB,
                padding: CryptoJS.pad.NoPadding,
            });
            result[ele] = encrypted.toString();
        });
    }
    return result;
};

// 深度克隆

export function deepClone(source) {
    if (!source && typeof source !== "object") {
        throw new Error("error arguments", "deepClone");
    }
    const targetObj = source.constructor === Array ? [] : {};
    Object.keys(source).forEach((keys) => {
        if (source[keys] && typeof source[keys] === "object") {
            targetObj[keys] = deepClone(source[keys]);
        } else {
            targetObj[keys] = source[keys];
        }
    });
    return targetObj;
}

// export const deepClone = obj => {
//   // 对常见的“非”值，直接返回原来值
//   if ([null, undefined, NaN, false].includes(obj)) return obj
//   if (typeof obj !== 'object' && typeof obj !== 'function') {
//     // 原始类型直接返回
//     return obj
//   }
//   const o = is_array(obj) ? [] : {}
//   for (const i in obj) {
//     // console.log(i)
//     // if (obj.prototype.hasOwnProperty.call(obj, i)) {
//     if (obj.hasOwnProperty(i)) {
//       o[i] = typeof obj[i] === 'object' ? deepClone(obj[i]) : obj[i]
//     }
//   }
//   return o
// }

/**
 * 是否数组
 */
// function is_array(value) {
//   if (typeof Array.isArray === 'function') {
//     return Array.isArray(value)
//   }
//   return Object.prototype.toString.call(value) === '[object Array]'
// }

/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
    let random = "";
    random = Math.ceil(Math.random() * 100000000000000)
        .toString()
        .substr(0, len || 4);
    if (date) random = random + Date.now();
    return random;
};

export const toDecimal2 = (number) => { 
    let result = Math.floor(number * 100) / 100;  
    if (result === Math.floor(result)) {  
        result += '.00';  
    } else {  
        result = result.toFixed(2);  
    }  
    return result;  
};
